export default __webpack_public_path__ + "static/media/gournay10.cd5d0d95.jpg";